import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// LOGIN
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));

// DASHBOARD: GENERAL
export const DashboardPage = Loadable(lazy(() => import('../pages/main/DashboardPage')));

// DASHBOARD: SKILLS
export const SkillsGlobalPage = Loadable(lazy(() => import('../pages/skills/SkillsGlobalPage')));
export const SkillsBlocksPage = Loadable(lazy(() => import('../pages/skills/SkillsBlocksPage')));
export const SkillsAgentsPage = Loadable(lazy(() => import('../pages/skills/SkillsAgentsPage')));
export const SkillGroupPage = Loadable(lazy(() => import('../pages/skills/groups/SkillGroupPage')));
// export const SkillGroupEdit = Loadable(lazy(() => import('../pages/skills/groups/SkillGroupEdit')));

// DASHBOARD: INTERFACE
export const InterfaceGlobalPage = Loadable(lazy(() => import('../pages/interface/InterfaceGlobalPage')));
export const InterfaceFormPage = Loadable(lazy(() => import('../pages/interface/InterfaceFormPage')));
export const InterfaceChatPage = Loadable(lazy(() => import('../pages/interface/InterfaceChatPage')));

// DASHBOARD: SETTINGS
export const SettingsPage = Loadable(lazy(() => import('../pages/main/SettingsPage')));

// ERROR
export const ErrorPage = Loadable(lazy(() => import('../pages/ErrorPage')));